function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { CubeGeometry } from '../geometry';
import { Model } from '../core';
import { uid } from '../utils';

var Cube = function (_Model) {
  _inherits(Cube, _Model);

  function Cube() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Cube);

    var _opts$id = opts.id,
        id = _opts$id === undefined ? uid('cube') : _opts$id;
    return _possibleConstructorReturn(this, (Cube.__proto__ || Object.getPrototypeOf(Cube)).call(this, Object.assign({}, opts, { id: id, geometry: new CubeGeometry(opts) })));
  }

  return Cube;
}(Model);

export { Cube as default };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RlbHMvY3ViZS5qcyJdLCJuYW1lcyI6WyJDdWJlR2VvbWV0cnkiLCJNb2RlbCIsInVpZCIsIkN1YmUiLCJvcHRzIiwiaWQiLCJPYmplY3QiLCJhc3NpZ24iLCJnZW9tZXRyeSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsU0FBUUEsWUFBUixRQUEyQixhQUEzQjtBQUNBLFNBQVFDLEtBQVIsUUFBb0IsU0FBcEI7QUFDQSxTQUFRQyxHQUFSLFFBQWtCLFVBQWxCOztJQUVxQkMsSTs7O0FBQ25CLGtCQUF1QjtBQUFBLFFBQVhDLElBQVcsdUVBQUosRUFBSTs7QUFBQTs7QUFBQSxtQkFDTUEsSUFETixDQUNkQyxFQURjO0FBQUEsUUFDZEEsRUFEYyw0QkFDVEgsSUFBSSxNQUFKLENBRFM7QUFBQSx1R0FFZkksT0FBT0MsTUFBUCxDQUFjLEVBQWQsRUFBa0JILElBQWxCLEVBQXdCLEVBQUNDLE1BQUQsRUFBS0csVUFBVSxJQUFJUixZQUFKLENBQWlCSSxJQUFqQixDQUFmLEVBQXhCLENBRmU7QUFHdEI7OztFQUorQkgsSzs7U0FBYkUsSSIsImZpbGUiOiJjdWJlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtDdWJlR2VvbWV0cnl9IGZyb20gJy4uL2dlb21ldHJ5JztcbmltcG9ydCB7TW9kZWx9IGZyb20gJy4uL2NvcmUnO1xuaW1wb3J0IHt1aWR9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgQ3ViZSBleHRlbmRzIE1vZGVsIHtcbiAgY29uc3RydWN0b3Iob3B0cyA9IHt9KSB7XG4gICAgY29uc3Qge2lkID0gdWlkKCdjdWJlJyl9ID0gb3B0cztcbiAgICBzdXBlcihPYmplY3QuYXNzaWduKHt9LCBvcHRzLCB7aWQsIGdlb21ldHJ5OiBuZXcgQ3ViZUdlb21ldHJ5KG9wdHMpfSkpO1xuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/models/cube.js
// module id = 569
// module chunks = 0